export const getTimeInMilliseconds = (): number => new Date().getTime();

export const getAgeInMilliseconds = (timestamp: number): number => getTimeInMilliseconds() - timestamp;

export const isTimestampOlderThan = (timestamp: number, maxAgeSeconds: number): boolean =>
  !!timestamp && !isNaN(timestamp) && getAgeInMilliseconds(timestamp) < maxAgeSeconds * 1000;
